import { render, staticRenderFns } from "./CreateFormMoreInfo.vue?vue&type=template&id=78450c08&scoped=true&"
import script from "./CreateFormMoreInfo.vue?vue&type=script&lang=js&"
export * from "./CreateFormMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./CreateFormMoreInfo.vue?vue&type=style&index=0&id=78450c08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78450c08",
  null
  
)

export default component.exports